import { render, staticRenderFns } from "./9.vue?vue&type=template&id=5f0199b0&scoped=true&"
import script from "./9.vue?vue&type=script&lang=js&"
export * from "./9.vue?vue&type=script&lang=js&"
import style0 from "./9.vue?vue&type=style&index=0&id=5f0199b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0199b0",
  null
  
)

export default component.exports